module.exports = __webpack_public_path__ + "img/alter-ego_en.2cb14fa.jpg";